<template>
    <div class="wonFailed">
        <el-dialog
            title="流标"
            :visible.sync="showWonFailedDialog"
            width="400px"
            :before-close="closeDialog">
            <span class="label">标段名称：</span>
            <el-input
                placeholder="请输入标段名称"
                v-model="extStr1s">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" :loading="loadding" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { wonFailed } from '../../../api/tenderDetails.js';
export default {
    name: 'won-failed-dialog',
    data () {
        return {
            extStr1s: '',
            loadding: false
        };
    },
    props: {
        showWonFailedDialog: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        tenderCode: {
            type: String,
            default: function() {
                return '';
            }
        },
        bidNo: {
            type: String,
            default: function() {
                return '';
            }
        }
    },
    components: {},
    methods: {
        closeDialog() {
            this.$emit('update:showWonFailedDialog', false);
        },
        confirm() {
            if (this.extStr1s) {
                const extStr1s = this.extStr1s.split('，');
                this.loadding = true;
                wonFailed({ tenderCode: this.tenderCode, extStr1s: extStr1s, bidNo: this.bidNo }).then(res => {
                    this.loadding = false;
                    if (res && res.code === '0') {
                        this.$message.success('更新成功');
                        this.$emit('updateTableData');
                        this.closeDialog();
                    }
                });
            } else {
                this.$message.warning('请输入线路名称');
            }
        }
    },
    mounted() {
    }
};
</script>
<style lang="less">
.wonFailed {
    .label {
        font-size: 14px;
    }
    .el-input {
        width: 70%;
    }
}
</style>